/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { GlobalStateService } from '../services/global.service.js';
/**
 *
 * The ClarityMotion service is a static class that gives users the ability to retrieve
 * and override animation configurations based on the Web Animations API that are targeted
 * at a CSS selector defined in the configuration.
 *
 */
export class ClarityMotion {
    /**
     * Returns a readonly reference of the registry of animations.
     */
    static get registry() {
        return { ...GlobalStateService.state.motionRegistry };
    }
    static has(name) {
        return !!name && !!ClarityMotion.registry[name];
    }
    static get(name) {
        return ClarityMotion.registry[name] || [];
    }
    static add(animationName, animationConfig) {
        if (!animationName || !animationConfig) {
            return;
        }
        GlobalStateService.state.motionRegistry = {
            ...GlobalStateService.state.motionRegistry,
            [animationName]: animationConfig,
        };
    }
}
